import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ScreenState } from "@/widgets/screen-state";

/**
 * Потеря сети — оверлей поверх текущего экрана, а НЕ роут.
 *
 * Роут потерял бы контекст: после восстановления связи некуда возвращаться,
 * а пользователь оказывался бы на главной вместо экрана, где он был.
 * Критерий закрытия фазы требует «корректного поведения при выключенной сети»,
 * и это как раз оно.
 */
export function OfflineOverlay() {
  const { t } = useTranslation();
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const goOffline = () => {
      setOffline(true);
    };
    const goOnline = () => {
      setOffline(false);
    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="animate-fade-in fixed inset-0 z-40 flex items-center justify-center bg-scrim-strong backdrop-blur-[2px]">
      <ScreenState tone="warning" icon="warningFill" title={t("states.offline.title")} body={t("states.offline.body")} />
    </div>
  );
}
